import axios from 'axios'

import store from '@/util/store'
import router from '@/util/router'
import {BACKEND_API_PREFIX} from '@/util/config'

function delay (time) {
  return new Promise((resolve, reject) => {
    setTimeout(function() {
      resolve()
    }, time)
  })
}

let post = async function (url, params) {
  let time = 50
  if (url.split(":").length <= 1) {
    url = BACKEND_API_PREFIX + url;
  }

  for (let i = 0; i < 3; i++) {
    try {
      let data = await trypost(url, params)
      return data
    } catch (e) {
      if (e) 
          console.log(e)
      else
          console.log("Got an empty exception in post"); 

      delay(time * (i + 1))
      continue
    }
  }
  return {}
}


let trypost = function (url, params) {

  let access_token = store.getters.getToken()
  let agent_key = store.getters.getAgentkey()
  let ip = store.getters.getIp()
  params["access_token"] = access_token
  params["agent_key"] = agent_key
  params["user_ip"] = ip

  return new Promise((resolve, reject) => {
    axios.post(url, params)
    .then(res => {
      let headers = res.headers
      if (headers.refresh) {
        store.commit('settoken', headers.refresh);
        store.commit('setstart', headers.restime/1000);
      }
      let rest = res.data
      if (rest.ret != 400) {
        resolve(res.data)
      }
      else if (rest.ret && rest.ret == 400) {
        localStorage.clear()
        reject(rest.msg)
        router.replace('/user/login') 
      } else {
        reject(rest.msg)
      }

    })
    .catch(err => {
      reject(err)
    })
  })
}

export default post
